import http from '@homeservices/api-kit/axios';

const SECTION_NAMES = {
  GETTING_STARTED: 'Getting Started',
  MID_LEVEL: 'Mid-level',
  PRO: 'Pro',
  PRO_XTRA: 'Learn More About Pro Xtra',
};
export default {
  namespaced: true,
  state () {
    return {
      extractedItemsByGroup: {},
      extractedItemsByCategory: {},
      videos: {},
      selectedVideos: {},
      videoRecords: [],
      sortedRecords: {},
      video: {},
      error: false,
    };
  },
  getters: {
    getExtractedItemsByGroup (state) {
      return state.extractedItemsByGroup;
    },
    getExtractedItemsByCategory (state) {
      return state.extractedItemsByCategory;
    },
    videoList (state) {
      return state.videos;
    },
    getSelectedVideosList (state) {
      return state.selectedVideos;
    },
    videoRecords (state) {
      return state.videoRecords;
    },
    sortedRecords (state) {
      return state.sortedRecords;
    },
    currentVideo (state) {
      return state.video;
    },
    quizError (state) {
      return state.error;
    },
  },
  actions: {
    async fetchVideos ({ commit, dispatch }, { serviceProviderId }) {
      if (serviceProviderId) {
        try {
          const { data } = await http.get('/api/contentful/educationvideos');
          const decodedData = JSON.parse(Buffer.from(data, 'base64').toString('utf-8'));

          commit('setVideos', decodedData);
          await dispatch('fetchVideoRecords', { serviceProviderId });
          dispatch('updateVideos', decodedData);
          dispatch('extractItemsByGroup', decodedData);
          dispatch('extractItemsByCategory', decodedData);
        } catch (error) {
          console.error('Error fetching videos:', error);
        }
      }
    },
    updateVideos ({ commit, getters, dispatch }, decodedData) {
      const data = { ...decodedData };
      Object.keys(decodedData).map((videoId) => {
        const id = decodedData[videoId].videoId;
        const match = getters.videoRecords
          .find(record => record.education_quiz_id === id);
        if (match) {
          data[id].current_status = match.education_quiz_status;
          data[id].serviceProviderEducationQuizId = match.id;
        }
        return data[id];
      });
      commit('setVideos', data);
      dispatch('sortVideoRecords');
    },
    async fetchVideoRecords ({ commit }, { serviceProviderId }) {
      try {
        const { data } = await http.get('/platform/serviceprovider/r/service-provider-education/v1', {
          params: {
            service_provider_ids: serviceProviderId,
          },
        });
        commit('setVideoRecords', data.results);
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    },
    extractItemsByGroup ({ commit }, items) {
      const groupNames = Object.values(SECTION_NAMES).map(item => item);
      const itemsByGroup = {};

      groupNames.forEach((name) => {
        itemsByGroup[name] = Object.keys(items)
          .filter(itemKey => items[itemKey].videoGroup === name);
      });
      const nonEmptyGroups = {};
      Object.keys(itemsByGroup).forEach((key) => {
        if (itemsByGroup[key].length > 0) {
          nonEmptyGroups[key] = itemsByGroup[key];
        }
      });

      commit('setExtractedItemsByGroup', nonEmptyGroups);
    },
    extractItemsByCategory ({ commit }, items) {
      const itemsByCategory = {};
      Object.keys(items).forEach((item) => {
        items[item].categories.forEach((categoryName) => {
          if (!itemsByCategory[categoryName]) {
            itemsByCategory[categoryName] = [];
          }
          itemsByCategory[categoryName].push(item);
        });
      });
      commit('setExtractedItemsByCategory', itemsByCategory);
    },
    sortVideoRecords ({ commit, getters }) {
      const sortedRecords = { Completed: [], 'In Progress': [] };
      getters.videoRecords.forEach((item) => {
        const { education_quiz_id, education_quiz_status } = item;
        if (Object.keys(getters.videoList).includes(education_quiz_id.toString())) {
          if (education_quiz_status === 'passed') {
            if (!sortedRecords.Completed.includes(education_quiz_id)) {
              sortedRecords.Completed.push(education_quiz_id);
            }
          }
          if (education_quiz_status === 'inprogress') {
            if (!sortedRecords['In Progress'].includes(education_quiz_id)) {
              sortedRecords['In Progress'].push(education_quiz_id);
            }
          }
          if (education_quiz_status === 'failed') {
            if (!sortedRecords['In Progress'].includes(education_quiz_id)) {
              sortedRecords['In Progress'].push(education_quiz_id);
            }
          }
        }
      });
      commit('setSortedRecords', sortedRecords);
    },
    async updateRecord (
      { dispatch },
      { service_provider_education_quiz_id, serviceProviderId, videoId, status }) {
      const now = new Date().toISOString();
      try {
        await http.post(`/platform/serviceprovider/r/service-provider-education-quiz/${service_provider_education_quiz_id}/v1`,
          {
            education_quiz_id: videoId,
            education_quiz_status: status,
            education_quiz_attempt_dtm: now,
            lifecycle_status: 'active',
          });

        dispatch('fetchVideos', serviceProviderId);
      } catch (error) {
        console.error('failed to create record', error);
      }
    },
    async createRecord ({ dispatch, getters }, { serviceProviderId, videoId, status }) {
      const recordIds = getters.videoRecords.map(record => record.education_quiz_id);
      const now = new Date().toISOString();
      if (!recordIds.includes(videoId)) {
        try {
          await http.post(`/platform/serviceprovider/r/service-provider-education/${serviceProviderId}/service-provider-education-quiz/v1`,
            {
              education_quiz_id: videoId,
              education_quiz_status: status,
              education_quiz_attempt_dtm: now,
              lifecycle_status: 'active',
            });
        } catch (error) {
          console.error('Error fetching videos:', error);
        }
      }
      dispatch('fetchVideoRecords', { serviceProviderId });
    },
    updateError ({ commit }, hasError) {
      commit('setError', hasError);
    },
  },
  mutations: {
    setExtractedItemsByGroup (state, itemsByGroup) {
      state.extractedItemsByGroup = itemsByGroup;
    },
    setExtractedItemsByCategory (state, itemsByCategory) {
      state.extractedItemsByCategory = itemsByCategory;
    },
    setSelectedVideos (state, data) {
      state.selectedVideos = data;
    },
    setVideos (state, data) {
      state.videos = data;
    },
    setVideo (state, data) {
      state.video = data;
    },
    setVideoRecords (state, data) {
      state.videoRecords = data;
    },
    setSortedRecords (state, data) {
      state.sortedRecords = data;
    },
    setError (state, data) {
      state.error = data;
    },
  },
};
